import {
  DocumentIcon_default
} from "./chunk-PV4X2D46.mjs";
export {
  DocumentIcon_default as default
};
